import styled from 'styled-components';

export const HeaderLogin = styled.div`
   background-color: #FF3232;
   padding: 7px 0;
   h2 {
       color: #fff;
       font-size: 1.4rem;
        text-transform: uppercase;
        font-weight: bold;
   }
`;

export const BodyLogin = styled.div`
    padding: 12px 12px 32px;
    max-width: 474px;
    margin: 0 auto;
`;
